import gql from 'graphql-tag';

// El usuario y su rol los resuelve el backend con la sesión; no se mandan como argumento.
export const CONSULTAR_PROCESOS_FACTOR_INTEGRACION = gql`
  query ConsultarProcesosFactorIntegracion($query: QueryInput!) {
    factorIntegracion {
      procesos(query: $query) {
        totalItems
        items {
          id
          tipo
          status
          fechaNegocio
          cliente
          totalProcesados
          totalFallidos
          total
          error
          fechaCreacion
          fechaFinalizacion
        }
      }
    }
  }
`;

export const OBTENER_DETALLE_PROCESO_FACTOR_INTEGRACION = gql`
  query ObtenerDetalleProcesoFactorIntegracion($procesoId: ID!) {
    factorIntegracion {
      detalle(procesoId: $procesoId) {
        id
        claveEmpleado
        nombreCompleto
        nombreCliente
        nombreGrupo
        nombreSucursal
        factorAnterior
        factorNuevo
        sdiAnterior
        sdiNuevo
        error
      }
    }
  }
`;

export const VISTA_PREVIA_FACTOR_INTEGRACION = gql`
  query VistaPreviaFactorIntegracion($fechaIngreso: Date) {
    factorIntegracion {
      vistaPrevia(fechaIngreso: $fechaIngreso)
    }
  }
`;

export const ANTIGUEDAD_VACACIONES = gql`
  query AntiguedadVacaciones(
    $ingreso: Date
    $antiguedad: Date
    $hasta: Date
    $anioEnCurso: Boolean
  ) {
    factorIntegracion {
      sherpa: antiguedad(desde: $ingreso, hasta: $hasta, anioEnCurso: $anioEnCurso) {
        anios
        diasVacaciones
      }
      cliente: antiguedad(desde: $antiguedad, hasta: $hasta, anioEnCurso: $anioEnCurso) {
        anios
        diasVacaciones
      }
    }
  }
`;
